import { render } from "./testimonial-six.vue?vue&type=template&id=59cf51b6"
import script from "./testimonial-six.vue?vue&type=script&lang=js"
export * from "./testimonial-six.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__